<i18n src="@/locales/modules/TodoListTranslate.json"></i18n>

<template>
    <el-dialog
        class="custom-nested-dialog todo-report-forms-dialog"
        destroy-on-close
        :visible.sync="isDialogActiveLocal"
        :before-close="handleBeforeCloseDialog"
        :title="`${$t('Report')} ${localValue.display_name}`"
    >
        <cbs-circle-steps
            v-if="isMultipleReport"
            class="justify-center my-3 sm:my-6"
            :value="stepsData"
            @onClickStep="handleClickStep"
        />

        <perfect-scrollbar>
            <cbs-dynamic-form
                class="p-6 pb-0"
                v-model="localValue.controls"
                :mappedAttachObj="mappedAttachObj"
                @onSetInitData="handleSetInitFormData"
                @onChangeMappedAttachObj="handleSetMappedAttachObj"
            />
        </perfect-scrollbar>

        <div class="flex justify-center" slot="footer">
            <vs-button
                class="font-bold w-full sm:w-1/3 px-1"
                @click="handleSubmitForm"
            >
                {{ $t(submitText) }}
            </vs-button>
        </div>
    </el-dialog>
</template>

<script>
import {
    cloneDeep as lodashCloneDeep,
    findIndex as lodashFindIndex,
    findLastIndex as lodashFindLastIndex
} from "lodash";
import { showConfirm } from "@/mixins/mixins.js";

import CbsCircleSteps from "@/components/cbs-circle-steps/CbsCircleSteps.vue";
import CbsDynamicForm from "@/components/cbs-dynamic-form/CbsDynamicForm.vue";

export default {
    name: "TodoReportFormsDialog",
    mixins: [showConfirm],
    components: {
        CbsDynamicForm,
        CbsCircleSteps
    },
    props: {
        value: {
            type: Object,
            required: true
        },
        isDialogActive: {
			type: Boolean,
			required: true
        },
        reportFormsData: {
            type: Array,
            required: true
        }
    },
    emits: {
        onSubmit: {},
        onClickStep: {}
    },
    provide() {
		return { parentValidator: this.$validator };
    },
    data() {
        return {
            isFormDirty: false,
            initFormData: null,
            mappedAttachObj: {}
        }
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            }
        },
        isDialogActiveLocal: {
			get() {
				return this.isDialogActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeDialog");
				}
			}
        },
        isMultipleReport() {
            return this.reportFormsData && this.reportFormsData.length > 1;
        },
        lastIsSubmittedIndex() {
            return lodashFindLastIndex(this.reportFormsData, { is_submited: true });
        },
        activeStepIndex() {
            return lodashFindIndex(this.reportFormsData, { id: this.value.id });
        },
        stepsData() {
            return this.reportFormsData.map((reportForm, index) => {
                const stepOrder = index + 1;
                return {
                    text: stepOrder,
                    id: reportForm.id,
                    isActive: this.activeStepIndex === index,
                    isEnable: index < this.activeStepIndex + 1 || index <= this.lastIsSubmittedIndex + 1
                };
            });
        },
        submitText() {
            if (!this.isMultipleReport || this.lastIsSubmittedIndex !== -1 && this.activeStepIndex === this.lastIsSubmittedIndex + 1) {
                return "CompleteReport";
			}
			return "SaveAndForward";
        }
    },
    watch: {
		localValue: {
			handler: function() {
				this.isFormDirty = JSON.stringify(this.localValue) !== JSON.stringify(this.initFormData);
			},
			deep: true
		}
	},
    methods: {
        handleSubmitForm() {
            this.$validator.validateAll().then(result => {
				if (result) {
					this.$emit("onSubmit");
				}
			});
        },
        handleSetMappedAttachObj(newMappedAttachObj) {
			this.mappedAttachObj = newMappedAttachObj;
        },
        handleBeforeCloseDialog(setDialogHide) {
			this.handleCloseDialog(setDialogHide, this.isFormDirty);
        },
        handleClickStep(data, index) {
            if (this.isFormDirty) {
                this.mixinShowConfirm({
                    text: this.$t("Notify.SwitchConfirm")
                }).then(isAccept => {
                    if (isAccept) {
                        this.$emit("onClickStep", this.reportFormsData.find(formData => formData.id === data.id) || data, index);
                    }
                });
            } else {
                this.$emit("onClickStep", this.reportFormsData.find(formData => formData.id === data.id) || data, index);
            }
        },
        handleSetInitFormData(controlsFormData) {
            this.initFormData.controls = lodashCloneDeep(controlsFormData);
            this.isFormDirty = JSON.stringify(this.localValue) !== JSON.stringify(this.initFormData);
		}
    },
    created() {
        this.initFormData = lodashCloneDeep(this.localValue);
        const localAttachsValue = this.localValue.attachs || [];
        localAttachsValue.forEach(attach => this.mappedAttachObj[attach.id] = attach);
    }
}
</script>

<style lang="scss" scoped>
.todo-report-forms-dialog.custom-nested-dialog {
    .ps {
        max-height: 60vh;

        @media screen and (max-height: 768px) {
            max-height: 50vh;
        }

        @media screen and (max-height: 576px) {
            max-height: 45vh;
        }

        @media screen and (max-height: 576px) and (orientation: landscape) {
            max-height: 30vh;
        }
    }

    ::v-deep .cbs-dynamic-form__control {
        &:first-child {
            margin-top: 0 !important;
        }
    }
}
</style>
